<template>
    <div :style="{width: 80 + 'px', height: 80 + 'px'}" class="relative flex items-center justify-center">
      <div :class="classListWrapper">
        <svg
            id="layout_thumbnail"
            data-layout-thumbnail-panes
            :viewBox="`0 0 ${layoutDimension.width} ${layoutDimension.height}`"
            :class="classList"
            class="relative transition-all cursor-pointer" :style="{'transform': selected ? 'scale(.75)' : 'scale(1)' }"
        >
          <rect
              data-border
              x="0"
              y="0"
              :width="layoutDimension.width"
              :height="layoutDimension.height"
              :fill="borderColor"
          />
          <svg
              v-for="pane in layout.panes"
              data-svg
              :viewBox="`0 0 ${((totalInnerWidth) / 100 * pane.width) - borderDimensions} ${((totalInnerHeight) / 100 * pane.height) - borderDimensions}`"
              :x="((totalInnerWidth) / 100 * pane.left) + borderDimensions"
              :y="((totalInnerHeight) / 100 * pane.top) + borderDimensions"
              :width="((totalInnerWidth) / 100 * pane.width) - borderDimensions"
              :height="((totalInnerHeight) / 100 * pane.height) - borderDimensions"
          >
            <rect
                x="0"
                y="0"
                width="100%"
                height="100%"
                fill="#9CA3B0"
            />
          </svg>
        </svg>
      </div>
      <Checkmark
          data-layout-thumnail-checkmark
          :checked="selected"
          class="absolute top-1/8 left-1/8 -translate-center z-50 m-1"
      />
    </div>
</template>

<script>
import Checkmark from '@vuedir/components/Checkmark'
import * as dimensions from '@vuedir/constants/dimensions'

/**
 * LayoutThumbnails.vue
 */
export default {

  components: {
    Checkmark
  },
  props: {
    layout: {
      type: Object,
      required: true,
    },
    customWidth: {
      type: Number,
      required: true,
    },
    customHeight: {
      type: Number,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    customSize: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      border: 1,
      borderColor: "#fff",
      edge: 0.75,
    }
  },

  computed: {

    layoutDimension () {
      let width;
      let height;
      if (this.customSize) {
        width = this.customWidth > this.customHeight ? 13 : 10
        height = this.customWidth < this.customHeight ? 13 : 10
      } else {
        width = this.layout.formfactor === dimensions.LANDSCAPE || this.layout.formfactor === dimensions.PANORAMA ? 13 : 10
        height = this.layout.formfactor === dimensions.PORTRAIT ? 13 : 10
      }

      return {
        width: width,
        height: height,
      }
    },

    totalInnerWidth () {
      return this.layoutDimension.width - this.borderDimensions
    },

    totalInnerHeight () {
      return this.layoutDimension.height - this.borderDimensions
    },

    aspectRatio () {
      return this.layoutDimension.width / this.layoutDimension.height
    },

    offset () {
      return this.borderDimensions / 2
    },

    borderDimensions () {
      return this.layoutDimension.width / 100 * this.border
    },

    classList () {
      return [
        'flex-1 max-w-full max-h-full absolute bottom-0 right-0 z-40 opacity-100',
        this.aspectRatio >= 1 ? 'w-full h-auto' : 'h-full w-auto',
      ]
    },

    classListWrapper () {
      return [
        'bg-gray-50 absolute',
        this.aspectRatio >= 1 ? 'w-full h-auto' : 'h-full w-auto',
      ]
    },
  },
}
</script>
